/**
 * Контроллер для управления канареечными куками, которые определяют
 * маршрутизацию трафика между новой (MM-WEB) и старой (KE-CUSTOMERS) версиями сайта.
 *
 * ВАЖНО: После установки кук необходимо дождаться истечения текущей сессии
 * для перехода на новую версию. Для принудительного переключения нужно
 * вручную удалить куку в DevTools браузера.
 *
 * https://eportal.magnit.ru/pages/viewpage.action?pageId=261693853
 * https://eportal.magnit.ru/pages/viewpage.action?pageId=261709507
 */
export class CanaryCookieController {
  /**
   * Включает новую версию сайта (MM-WEB)
   * Устанавливает куку nuxt=always для маршрутизации на новую версию
   */
  public static enableNewVersion(): void {
    document.cookie = 'nuxt=always; path=/; max-age=31536000';
  }

  /**
   * Включает старую версию сайта (KE-CUSTOMERS)
   * Устанавливает куку nuxt=never для маршрутизации на старую версию
   */
  public static enableLegacyVersion(): void {
    document.cookie = 'nuxt=never; path=/; max-age=31536000';
  }

  /**
   * Проверяет наличие куки nuxt и возвращает её значение
   * @returns Значение куки ('always', 'never') или null, если кука отсутствует
   */
  public static getCookieValue(): string | null {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'nuxt') {
        return value || null;
      }
    }
    return null;
  }

  /**
   * Проверяет, установлена ли кука nuxt
   * @returns true, если кука существует, false в противном случае
   */
  public static hasCookie(): boolean {
    return this.getCookieValue() !== null;
  }

  /**
   * Проверяет, включена ли новая версия сайта (MM-WEB)
   * @returns true, если кука установлена в 'always', false в противном случае
   */
  public static isNewVersionEnabled(): boolean {
    return this.getCookieValue() === 'always';
  }

  /**
   * Проверяет, включена ли старая версия сайта (KE-CUSTOMERS)
   * @returns true, если кука установлена в 'never', false в противном случае
   */
  public static isLegacyVersionEnabled(): boolean {
    return this.getCookieValue() === 'never';
  }
}
